import _Set from '@babel/runtime-corejs3/core-js/set';
import _valuesInstanceProperty from '@babel/runtime-corejs3/core-js/instance/values';

var imagesInCache = new _Set();
var CACHE_SIZE = 2000;
function addToCache(imageUrl) {
  // 将本次浏览载入过的图片的 URL 保存起来。如果之后有相同图片需要载入，可以直接从浏览器缓存中读取加载，
  // 不需要再走懒加载的流程。
  if (imagesInCache.size > CACHE_SIZE) {
    var firstImageInCache = _valuesInstanceProperty(imagesInCache).call(imagesInCache).next().value;

    imagesInCache.delete(firstImageInCache);
  }

  imagesInCache.add(imageUrl);
}
function isImageInCache(imageUrl) {
  return imagesInCache.has(imageUrl);
}

export { addToCache, isImageInCache };
